module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOS4wOCAxNi4zNiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5tZW5zPC90aXRsZT48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTAuMjkgMCA4LjkyIDEuNDcgMTUuMDcgNy4xOCAwIDcuMTggMCA5LjE4IDE1LjA3IDkuMTggOC45MiAxNC44OSAxMC4yOSAxNi4zNiAxOS4wOCA4LjE4IDEwLjI5IDAiLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/arrow.svg
// module id = SZdR
// module chunks = 0